import { Injectable } from '@angular/core';
import { PolicyPaymentDetailes } from 'src/app/features/policy/policy-purchase-details/policy-purchase-details.component';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  policyNo:string='';
  referenceNumber:string='';
  errorMessage:string='';
  isError:boolean=false;
  constructor() { }

  setPolicyPaymentDetailes(policyNo:string,referenceNumber:string,isError:boolean,errorMessage:string){
    this.policyNo=policyNo;
    this.referenceNumber=referenceNumber;
    this.isError=isError;
    this.errorMessage=errorMessage;
  }

  getPolicyPaymentDetailes():PolicyPaymentDetailes{
    return {
      policyNo:this.policyNo,
      referenceNumber:this.referenceNumber,
      isError:this.isError,
      errorMessage:this.errorMessage
    };
  }
}
